export const selectNameFilter = state => state.filters.filters.name;
